<template>
  <div
    id="booking-verify"
    class="app-main-content"
  >
    <warehousing-tree-grid
      v-show="view==='list'"
      ref="warehousingTreeGrid"
      :context="context"
      :lob="lob"
      @look="lookHandle"
      @edit="editHandle"
      @add="addHandle"
      @print="onPrintHandler"
      @refresh="refreshHandle"
    />
    <warehousing-workspace
      v-show="view==='detail'"
      ref="warehousingWorkspace"
      :parent-context="context"
      :lob="lob"
      @add="addHandle"
      @edit="editHandle"
      @look="lookHandle"
      @back="backToList"
      @print="onPrintHandler"
      @refresh="refreshHandle"
    />

    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      ref="templateSelectorDialog"
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :context="context"
      :pre-print-callback="prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
    />
  </div>
</template>

<script>
import jobNoRuleSelector from '@/components/Cargo/Job/jobNoRuleSelector'
import warehousingTreeGrid from './components/warehousing/warehousingTreeGrid'
import warehousingWorkspace from './components/warehousing/warehousingWorkspace'
import { WarehousingContext } from './components/warehousing/warehousingContext'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'

export default {
  name: 'WarehousingInStack',
  components: { warehousingTreeGrid, warehousingWorkspace, jobNoRuleSelector, cargoTemplateSelectorDialog },
  props: {
    lob: { type: String, required: true }
  },
  data() {
    return {
      context: WarehousingContext.getInstance(),
      view: 'list',
      templateSelectorDialog: {
        visible: false,
        category: '',
        data: {}
      },
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null
    }
  },
  computed: {
    officeId() {
      return this.$store.getters.currentOfficeId
    },
    office() {
      return this.context.office
    }
  },
  watch: {
    officeId: {
      async handler(newVal) {
        if (this.office.officeId !== this.officeId) {
          await this.context.prepareData()
        }
      }
    }
  },
  created() {
    this.context.prepareData()
  },
  methods: {
    lookHandle(row) {
      this.detailHandle('look', row)
    },
    editHandle(row) {
      this.detailHandle('edit', row)
    },
    addHandle() {
      this.detailHandle('add', { uuid: '' })
    },
    backToList(isRefresh) {
      const rowData = this.$refs.warehousingWorkspace.rowData
      this.view = 'list'
      if (!isRefresh) {
        this.$refs.warehousingTreeGrid.toQuery(rowData)
      } else {
        this.$refs.warehousingTreeGrid.updateListData(rowData)
      }
    },
    // 打印
    onPrintHandler(row) {
      if (row.length === 0) {
        return
      }
      const params = this.getPrintData(row)
      if (!params) return

      this.templateSelectorDialog.category = 'WAREHOUSE'
      this.templateSelectorDialog.data = params
      this.templateSelectorDialog.visible = true
    },
    // 组装打印参数
    getPrintData(rows) {
      const params = {}
      const uuids = []
      for (const key in rows) {
        const warehouseIn = rows[key]
        uuids.push(warehouseIn.uuid)
      }
      params.WAREHOUSE_UUID = uuids
      params.category = 'WAREHOUSE'
      params.USER_ID = this.context.user.userId
      return params
    },
    // 进详情公共
    detailHandle(type, row) {
      let rowData = null
      if (this.view === 'detail') {
        rowData = this.$refs.warehousingWorkspace.rowData
      } else {
        this.view = 'detail'
        rowData = this.$refs.warehousingTreeGrid.rowData
      }
      this.$refs.warehousingWorkspace.onShow(type, rowData, row)
    },
    splitHandle(row) {
      this.detailHandle('split', row)
    },
    // 操作成功后刷新详情
    refreshHandle(row) {
      this.detailHandle('look', row)
    }
  }
}
</script>

<style lang="scss">
</style>
